import React from "react";
import employmentImg from "../../assets/img/careers/employment.png";
import Reveal from "../common/Reveal";
import NetworkBackground from "../common/NetworkBackground";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary-50 to-white">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <NetworkBackground className="absolute inset-0 h-full w-full" density={40} />
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">
        {/* 텍스트 영역 */}
        <Reveal>
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold tracking-wide text-primary-700">
            CAREERS
          </span>
          <h1 className="mt-6 break-keep text-4xl font-bold leading-tight text-primary-900 sm:text-5xl">
            서로 다른 사람들이 모여
            <br />
            한 방향으로 나아갑니다
          </h1>
          <p className="mt-6 max-w-xl break-keep text-lg leading-relaxed text-gray-600">
            MTST는 구성원 개개인의 성장이 곧 회사의 성장으로 이어진다고
            믿습니다. 스스로 도전하며 배우고, 그렇게 쌓은 성장을 회사와
            함께 나누고 싶은 분이라면 미래의{" "}
            <strong className="text-primary-900">MTST</strong>인에 지금
            도전하세요.
          </p>
          <div className="mt-10">
            <a
              href="mailto:mtst@mtstech.kr"
              className="inline-flex items-center rounded-md bg-primary-800 px-6 py-3.5 text-base font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-700 hover:shadow-lg"
            >
              채용 문의하기
            </a>
          </div>
        </Reveal>

        {/* 이미지 영역 */}
        <Reveal direction="left" delay={100} className="flex justify-center">
          <div className="aspect-square w-full max-w-sm overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-primary-100 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl">
            <img
              src={employmentImg}
              alt="MTST에서 협업하며 일하는 모습"
              className="h-full w-full object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
